/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SquareArrowRightRegular from './square-arrow-right-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SquareArrowRightRegular {...validProps} />;
}

SvgComponent.iconName = 'squareArrowRightRegular';

export const SquareArrowRightRegularIcon = svgIconWrapper(SvgComponent);
